import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, DatePicker, Icon, toast } from '@livable/saas-react-components';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { formatISO } from 'date-fns';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DumbFileUploader from 'src/components/shared/DumbFileUploader';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const RentDetailsTab = observer(_ref => {
  let residencyId = _ref.residencyId,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGlobalChange = _useState2[0],
    setIsGlobalChange = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    startDate = _useState4[0],
    setStartDate = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    roommatesAsync = _useState6[0],
    setRoommatesAsync = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    upoloadFile = _useState8[0],
    setUpoloadFile = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    downloadedFile = _useState0[0],
    setDownloadedFile = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    leaseAddendumFileId = _useState10[0],
    setLeaseAddendumFileId = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    filePreviewLink = _useState12[0],
    setFilePreviewLink = _useState12[1];
  const getDifference = (array1, array2) => {
    return array1.filter(object1 => {
      return !array2.some(object2 => {
        return object1.firstname == object2.firstName && object1.lastname == object2.lastName && object1.email == object2.email && object1.roommateId == object2.id;
      });
    });
  };
  const validationHandler = _ref2 => {
    let _ref2$currentStartDat = _ref2.currentStartDate,
      currentStartDate = _ref2$currentStartDat === void 0 ? null : _ref2$currentStartDat,
      _ref2$currentFile = _ref2.currentFile,
      currentFile = _ref2$currentFile === void 0 ? false : _ref2$currentFile;
    const currentUploadFile = currentFile !== false ? currentFile : upoloadFile;
    const currentLeaseStartDate = !!currentStartDate ? formatISO(currentStartDate).split('T')[0] : !!startDate ? formatISO(startDate).split('T')[0] : null;
    const roommatesData = {
      toCreate: [],
      toUpdate: [],
      toDelete: []
    };
    roommatesAsync.map(item => {
      if (store.roommates.roommatesOwerview.findIndex(i => i.id === item.id) === -1) {
        roommatesData.toDelete.push(item.id);
      }
    });
    toJS(store.roommates.roommatesOwerview).map(item => {
      if (item.id) {
        roommatesData.toUpdate.push({
          roommateId: item.id,
          firstname: item.firstName,
          lastname: item.lastName,
          email: item.email
        });
      } else {
        roommatesData.toCreate.push({
          firstname: item.firstName,
          lastname: item.lastName,
          email: item.email
        });
      }
    });
    if (currentUploadFile === downloadedFile && currentLeaseStartDate === store.residencies.leaseDetails.leaseStartDateOnly && !roommatesData.toCreate.length && !roommatesData.toDelete.length && !getDifference(roommatesData.toUpdate, roommatesAsync).length) {
      setIsGlobalChange(false);
      return;
    }
    if (currentUploadFile !== downloadedFile) {
      setFilePreviewLink('');
      setDownloadedFile(currentFile === null || currentFile === void 0 ? void 0 : currentFile.name);
    }
    setIsGlobalChange(true);
  };
  const handleFileChange = currentFile => {
    if (!currentFile) {
      setUpoloadFile(null);
      validationHandler({
        currentFile: null
      });
    } else {
      setUpoloadFile(currentFile);
      validationHandler({
        currentFile: currentFile
      });
    }
  };
  const asyncDataLoading = async () => {
    const resp = await store.residencies.getResidencyLeaseDetailsAsync.run({
      residencyId: residencyId
    });
    if (!resp || !resp.isSuccessful) return;
    if (resp.response.leaseStartDateOnly) setStartDate(moment(resp.response.leaseStartDateOnly).toDate());
    const curentRoommates = await store.roommates.getAllRoommatesRelatedToSpecificResidencyAsync.run({
      residencyId: residencyId
    });
    if (!curentRoommates || !curentRoommates.isSuccessful) return;
    setRoommatesAsync(curentRoommates.response);
    const currentFiles = resp.response.leaseAddendumFileIds;
    setDownloadedFile(null);
    if (currentFiles && currentFiles.length > 0) {
      const currentFilesData = await store.files.getFileInfoAsync.run({
        fileId: currentFiles[0]
      });
      if (!currentFilesData || !currentFilesData.isSuccessful) return;
      setDownloadedFile(currentFilesData.response.fileName);
      setUpoloadFile(currentFilesData.response.fileName);
      setLeaseAddendumFileId(currentFilesData.response.fileId);
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        var _currentFilesData$res;
        const fileNamePartials = currentFilesData === null || currentFilesData === void 0 || (_currentFilesData$res = currentFilesData.response) === null || _currentFilesData$res === void 0 ? void 0 : _currentFilesData$res.fileName.split('.');
        if (['doc', 'docx'].includes(fileNamePartials[fileNamePartials.length - 1])) {
          const requestFilePreviewLinkResp = await store.files.getRequestPreviewLinkAsync.run({
            fileId: currentFilesData.response.fileId
          });
          if (requestFilePreviewLinkResp.isSuccessful) {
            setFilePreviewLink(requestFilePreviewLinkResp.response);
          }
        } else {
          const filePreviewLinkResp = await store.files.getPresignedFileDownloadUrlAsync.run({
            fileId: currentFilesData.response.fileId,
            isPreview: true
          });
          if (filePreviewLinkResp !== null && filePreviewLinkResp !== void 0 && filePreviewLinkResp.isSuccessful) {
            setFilePreviewLink(filePreviewLinkResp.response);
          }
        }
      } else {
        var _currentFilesData$res2;
        setFilePreviewLink(store.files.getFilePreviewLink({
          fileId: currentFilesData.response.fileId
        }, false, ".".concat(currentFilesData === null || currentFilesData === void 0 || (_currentFilesData$res2 = currentFilesData.response) === null || _currentFilesData$res2 === void 0 || (_currentFilesData$res2 = _currentFilesData$res2.fileName) === null || _currentFilesData$res2 === void 0 || (_currentFilesData$res2 = _currentFilesData$res2.split('.').pop()) === null || _currentFilesData$res2 === void 0 ? void 0 : _currentFilesData$res2.toLowerCase())));
      }
    }
  };
  const handleSubmit = async () => {
    let upoloadFileId = null;
    const currentLeaseStartDate = !!startDate ? formatISO(startDate).split('T')[0] : null;
    const roommatesData = {
      toCreate: [],
      toUpdate: [],
      toDelete: []
    };
    roommatesAsync.map(item => {
      if (store.roommates.roommatesOwerview.findIndex(i => i.id === item.id) === -1) {
        roommatesData.toDelete.push(item.id);
      }
    });
    toJS(store.roommates.roommatesOwerview).map(item => {
      if (item.id) {
        roommatesData.toUpdate.push({
          roommateId: item.id,
          firstname: item.firstName,
          lastname: item.lastName,
          email: item.email
        });
      } else {
        roommatesData.toCreate.push({
          firstname: item.firstName,
          lastname: item.lastName,
          email: item.email
        });
      }
    });
    if (!!leaseAddendumFileId && (upoloadFile && upoloadFile !== downloadedFile || !upoloadFile || !downloadedFile)) {
      await store.files.deleteFileAsync.run({
        fileId: leaseAddendumFileId
      }).then(resp => {
        if (resp.isSuccessful) {
          setLeaseAddendumFileId(null);
        } else {
          return;
        }
      });
    }
    if (upoloadFile && upoloadFile !== downloadedFile) {
      let uploadFileResult;
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        uploadFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
          file: upoloadFile,
          createdBy: store.account.userProfile.id
        });
      } else {
        uploadFileResult = await store.files.uploadFileAsync.run({
          file: upoloadFile
        });
      }

      // const uploadFileResult = await store.files.uploadFileAsync.run({
      //   file: upoloadFile,
      // });

      if (!uploadFileResult || !uploadFileResult.isSuccessful) {
        return;
      }
      upoloadFileId = uploadFileResult.response;
    }
    if (currentLeaseStartDate !== store.residencies.leaseDetails.leaseStartDateOnly || upoloadFile !== downloadedFile) {
      const updateResidencyLeaseDetails = await store.residencies.updateResidencyLeaseDetailsAsync.run({
        residencyId: residencyId,
        leaseStartDateOnly: currentLeaseStartDate,
        leaseAddendumFileId: upoloadFile === null ? '' : upoloadFileId
      });
      if (!updateResidencyLeaseDetails || !updateResidencyLeaseDetails.isSuccessful) {
        return;
      }
    }
    if (roommatesData.toCreate.length || roommatesData.toDelete.length || getDifference(roommatesData.toUpdate, roommatesAsync).length) {
      const updateRoommates = await store.roommates.updateRoommatesAssociatedWithResidencyByIdAsync.run({
        residencyId: residencyId,
        data: roommatesData
      });
      if (!updateRoommates || !updateRoommates.isSuccessful) {
        return;
      }
    }
    await asyncDataLoading();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    parentToggleRefreshCallback && parentToggleRefreshCallback();
    toast('success', {
      body: ['Successfully saved']
    });
  };
  useEffect(() => {
    asyncDataLoading();
    return () => {
      store.roommates.resetState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWithFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('unit_modal.lease_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.leaseDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(store.company.companyFeatureStore.readOnlyLeaseDetails ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: startDate,
    onChange: date => {
      setStartDate(date);
      validationHandler({
        currentStartDate: date
      });
    },
    format: "MM/dd/yy",
    label: t('unit_modal.lease_start_date')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.mdSection, " ").concat(classes.file, " ").concat(store.company.companyFeatureStore.readOnlyLeaseDetails ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement(DumbFileUploader, {
    label: t('unit_modal.addendum_optional') + "".concat(store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? ' (Max. 100 MB)' : ''),
    callback: handleFileChange,
    downloadName: downloadedFile,
    filePreviewLink: filePreviewLink
  })), !store.company.companyFeatureStore.disableRoommate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('unit_modal.who_else'))), store.roommates.roommatesOwerview.map((elem, i) => /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection,
    key: i
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 18,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.first_name'),
    variant: "outlined",
    fullWidth: true,
    value: store.roommates.roommatesOwerview[i].firstName,
    onChange: e => {
      store.roommates.changeRoommatesOwerviewUnit(i, 'firstName', e.target.value);
      validationHandler({});
    },
    onBlur: () => store.roommates.changeFieldTouched(i, 'firstName'),
    error: !!store.roommates.roommatesOwerviewTouched[i].firstName && !!store.roommates.roommatesOwerviewValidation[i].firstName,
    helperText: !!store.roommates.roommatesOwerviewTouched[i].firstName && store.roommates.roommatesOwerviewValidation[i].firstName
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.last_name'),
    variant: "outlined",
    fullWidth: true,
    value: store.roommates.roommatesOwerview[i].lastName,
    onChange: e => {
      store.roommates.changeRoommatesOwerviewUnit(i, 'lastName', e.target.value);
      validationHandler({});
    },
    onBlur: () => store.roommates.changeFieldTouched(i, 'lastName'),
    error: !!store.roommates.roommatesOwerviewTouched[i].lastName && !!store.roommates.roommatesOwerviewValidation[i].lastName,
    helperText: !!store.roommates.roommatesOwerviewTouched[i].lastName && store.roommates.roommatesOwerviewValidation[i].lastName
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emailFieldContainer
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.email_address_optional'),
    variant: "outlined",
    fullWidth: true,
    value: store.roommates.roommatesOwerview[i].email,
    onChange: e => {
      store.roommates.changeRoommatesOwerviewUnit(i, 'email', e.target.value);
      validationHandler({});
    },
    onBlur: () => store.roommates.changeFieldTouched(i, 'email'),
    error: !!store.roommates.roommatesOwerviewTouched[i].email && !!store.roommates.roommatesOwerviewValidation[i].email,
    helperText: !!store.roommates.roommatesOwerviewTouched[i].email && store.roommates.roommatesOwerviewValidation[i].email
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      store.roommates.removeRoommatesOwerviewUnit(i);
      validationHandler({});
    },
    'custom-attribute': '260-rent-details-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: () => {
      store.roommates.addRoommatesOwerviewUnit();
      validationHandler({});
    },
    'custom-attribute': '261-rent-details-tab'
  }, t('unit_modal.add_person'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    onClick: handleSubmit,
    disabled: !isGlobalChange || store.roommates.roommatesOwerviewValidation.filter(item => item.firstName && item.firstName.length > 0 || item.lastName && item.lastName.length > 0 || item.email && item.email.length > 0).length > 0,
    'custom-attribute': '262-rent-details-tab'
  }, t('buttons.submit'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.files.getFileInfoAsync.inProgress || store.residencies.getResidencyLeaseDetailsAsync.inProgress || store.roommates.getAllRoommatesRelatedToSpecificResidencyAsync.inProgress || store.files.uploadFileAsync.inProgress || store.files.uploadFileViaPresignedUrlExperimentAsync.inProgress || store.residencies.updateResidencyLeaseDetailsAsync.inProgress || store.roommates.updateRoommatesAssociatedWithResidencyByIdAsync.inProgress
  }));
});